import { createSelector } from '@reduxjs/toolkit'
import { APISectorDetailKeyType } from '@/models/map'
import { mapSelectedElementSetupDataSelector } from '@/store/mapSlice'
import { activeElementQuotedSeatsAmountSelector } from './activeElementQuotedSeatsAmountSelector'

export const areDrawerButtonsEnabledSelector = createSelector(
  [activeElementQuotedSeatsAmountSelector, mapSelectedElementSetupDataSelector],
  (selectedElementQuotedSeatsAmount, setupData) => {
    const selectedElementSetupLimit = setupData?.selectedElementSetupLimit

    const isMinimumSeatAmountRespected =
      selectedElementSetupLimit &&
      selectedElementQuotedSeatsAmount >=
        selectedElementSetupLimit[APISectorDetailKeyType.MIN]

    return !!isMinimumSeatAmountRespected
  }
)
